<template>
    <div class="container">
        <div class="param_title">贷款信息</div>
        <el-table
                :data="loantableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header">
                <el-table-column
                    v-for="col in loantableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="scope.column.property ==='Operation'">
                                <el-button
                                    size="mini"
                                     type="primary"
                                     icon="el-icon-edit"
                                    @click="handleEdit(scope.$index, scope.row)">修改
                                </el-button>
                            </div>
                            <div v-else-if="(scope.column.property==='IsShow')">
                                <span v-if="(scope.row.IsShow=='1')">生效</span>
                                <span v-else>不生效</span>
                            </div>
                            <div v-else-if="(scope.column.property==='IsCodeShow')">
                                <span v-if="(scope.row.IsCodeShow=='1')">生效</span>
                                <span v-else>不生效</span>
                            </div>
                            <div v-else-if="(scope.column.property==='MaxMoney')">
                                <span v-if="(scope.row.MaxMoney==null)">不限额</span>
                                <span v-else>{{ scope.row.MaxMoney }}</span>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
            
    
            <div style="margin-top: 30px;" class="param_title">模版信息</div>
            <div class="addBtn">
                 <el-button size="mini" type="danger" icon="el-icon-plus" @click="handleAdd">新增模板</el-button> 
                   <!-- <el-upload
                                accept=".pdf"
                                v-show="false"
                                class="templateUpload"
                                ref="templateUpload"
                                :http-request="uploadFile"
                                :on-success="uploadSuccess">
                            </el-upload> -->
            </div>
           <el-table
                :data="tableData"
                border
                :max-height="scrollHeight"
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                 <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="handleUpdate(scope.row)">修改</el-button>
                                 <!-- <el-button
                                 icon="el-icon-delete"
                                size="mini"
                                type="danger"
                                @click="handleDelete( scope.row)">删除</el-button> -->
                                <el-button
                                 icon="el-icon-info"
                                size="mini"
                                type="info"
                                @click="handleView(scope.row)">模版预览</el-button>
                            </div>
                            <div v-else-if="(scope.column.property==='IsSelect')">
                                <span v-if="(scope.row.IsSelect=='1')">生效</span>
                                <span v-else>不生效</span>
                            </div>
                            <div v-else-if="(scope.column.property==='Type')">
                                <span v-if="(scope.row.Type=='1')">个人</span>
                                <span v-else>公司</span>
                            </div>
                            <div v-else-if="(scope.column.property==='myParty')">
                                {{ getPartyName(scope.row) }}
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
             <!-- 详情弹出框 -->
       
                    <div style="margin-top: 30px;" class="param_title">其他设置</div>
            <div class="addBtn">
                 <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleChangePhone">解绑手机号</el-button> 
                  <el-button size="mini" type="primary" icon="el-icon-message" @click="handleWxMessage">公众号消息</el-button> 
            </div>
                <el-dialog title="变更" v-model="changeVisible" width="600px" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="140px">
                           <el-row>
                    <el-col :span="22">
                        <el-form-item label="流程编号">
                             <el-input
                                v-model="dataDetail.Id"
                                size="small"
                                placeholder="请输入编号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                 <el-col :span="22">
                         <el-form-item label="用户：">
                            <el-select v-model="dataDetail.actor" size="small" placeholder="请选择" >
                                    <el-option label="申请用户" value="5"></el-option>
                                    <el-option label="用户配偶" value="6"></el-option>
                                </el-select>
                                </el-form-item> </el-col>
                       
                </el-row>
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="changeVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="changePhone">提交</el-button>
                </div>
        </el-dialog>

         <el-dialog title="公众号消息推送" v-model="wxMessageVisible" width="600px" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="140px">
                           <el-row>
                    <el-col :span="22">
                        <el-form-item label="流程编号">
                             <el-input
                                v-model="dataDetail.Id"
                                size="small"
                                placeholder="请输入编号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="wxMessageVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="wxMessageSend">发送</el-button>
                </div>
        </el-dialog>
        <el-dialog :title="type=='add'?'新增' : '修改'" v-model="detailVisible" width="600px" top="6vh">
            <el-form ref="detailForm"  :model="dataDetail" label-width="140px">
                           <el-row>
                    <el-col :span="22">
                        <el-form-item label="法大大模版编号：">
                             <el-input
                                v-model="dataDetail.FddTemplateId"
                                size="small"
                                placeholder="请输入编号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="模板名称：">
                             <el-input
                                v-model="dataDetail.Name"
                                size="small"
                                placeholder="请输入名称"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                       <el-col :span="22">
                        <el-form-item label="经办人姓名：">
                             <el-input
                                v-model="dataDetail.FddUserName"
                                size="small"
                                placeholder="请输入姓名"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                       <el-col :span="22">
                        <el-form-item label="经办人法大大号：">
                             <el-input
                                v-model="dataDetail.FddUserCode"
                                size="small"
                                placeholder="请输入法大大号"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                     
                <el-row>
                    <el-col :span="22">
                        <el-form-item label="参与方：">
                        <el-select
                          v-model="newPartys"
                          multiple
                          size="small"
                          clearable
                          placeholder="请选择"
                          style="width: 390px;"
                        >
                            <el-option
                              v-for="item in partyList"
                              :key="item.Id"
                              :label="item.Name"
                              :value="item.Id"
                            />
                        </el-select>
                    </el-form-item>
                    </el-col>
                     <el-col :span="22"> 
                        <el-form-item label="合同类型：">
                              <el-select v-model="dataDetail.Type" size="small" placeholder="请选择" >
                                    <el-option label="个人" value="1"></el-option>
                                    <el-option label="公司" value="2"></el-option>
                                     <!-- <el-option label="通用" value="3"></el-option> -->
                                </el-select>
                        </el-form-item>
                    </el-col> <el-col :span="22">
                         <el-form-item label="是否生效：">
                            <el-select v-model="dataDetail.IsSelect" size="small" placeholder="请选择" >
                                    <el-option label="不生效" value="0"></el-option>
                                    <el-option label="生效" value="1"></el-option>
                                </el-select>
                               <!-- <el-radio v-model="dataDetail.IsSelect" label="0">不生效</el-radio>
                               <el-radio v-model="dataDetail.IsSelect" label="1">生效</el-radio> -->
                        </el-form-item>
                    </el-col> 
                    <!-- <el-col :span="22">
                        <el-form-item  label="模板文件：">
                             <span class="FileLink"  @click="handlePicDownload(dataDetail)">下载</span>
                        </el-form-item>
                    </el-col>  -->

                    <!-- <el-col :span="11">
                        <el-form-item label="选择参数：">
                <el-tree
				:data="paramList"
                node-key="Id"
				ref="paramTree"
				show-checkbox
			     />
                        </el-form-item>
                    </el-col> -->
                </el-row>
                 
                <el-row>
                    <el-col :span="22">
                     
                    </el-col>
                       
                </el-row>
            </el-form>
                <div class="dialog-Btn">
                    <el-button size="small" @click="detailVisible = false">取 消</el-button>
                    <el-button size="small" type="primary" @click="addOrUpdate">提交</el-button>
                </div>
        </el-dialog>

        <el-dialog title="修改应急贷款信息" custom-class="loanManagePanel" v-model="editVisible" width="700px">
            <el-form :rules="rules" ref="loanruleForm" class="loanManageClass" :model="returnItem" label-width="180px">
                <el-form-item label="贷款类型名称" :label-width="formLabelWidth"  prop="LoanName" >
                    <el-input v-model="returnItem.LoanName"></el-input>
                </el-form-item>
                <el-form-item label="最高贷款金额（万元）" :label-width="formLabelWidth"  >
                    <el-input v-model="returnItem.MaxMoney" 
                    oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.'))}"></el-input>
                </el-form-item>
                <el-form-item label="参考利率（‱）" :label-width="formLabelWidth" prop="RatStart" >
                    <el-input v-model="returnItem.RatStart"></el-input>
                </el-form-item>
                 <el-form-item label="付息信息" :label-width="formLabelWidth">
                    <el-input v-model="returnItem.Tips1"></el-input>
                </el-form-item>
                <el-form-item label="贷款时长" :label-width="formLabelWidth">
                    <el-input v-model="returnItem.Tips2"></el-input>
                </el-form-item>
                <el-form-item label="是否生效：">
                            <el-select v-model="returnItem.IsShow" size="small" placeholder="请选择" >
                                    <el-option label="不生效" value="0"></el-option>
                                    <el-option label="生效" value="1"></el-option>
                                </el-select>
                </el-form-item>
                <el-form-item label="短信验证码：">
                            <el-select v-model="returnItem.IsCodeShow" size="small" placeholder="请选择" >
                                    <el-option label="不生效" value="0"></el-option>
                                    <el-option label="生效" value="1"></el-option>
                                </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button style="margin:0px 10px;" @click="editVisible = false">取消</el-button>
                    <el-button style="margin:0px 10px;" type="primary" @click="addEditChange()">保存</el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import indexJs from "./index.js";
  export default indexJs;
</script>
<style scoped>
.dialog-Btn{
    text-align: center;
}
.FileLink{
    color: red;
    cursor: pointer;
    margin-right: 40px;
}
.param_title{
    font-weight: bold;
    font-size: 20px;
    padding-left: 10px;
    padding-bottom: 10px;
}
</style>